import { IContactInfo } from '@/interface/contact';

export const createContact = async (payload: IContactInfo): Promise<Partial<{ message: string }>> => {
  return await new Promise((resolve, reject) => {
    fetch('https://us-central1-teckat-clients.cloudfunctions.net/contactUs', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'Application/Json' },
    })
      .then(async (response) => {
        const res = await response.json();
        if (res.statusCode >= 400) {
          reject(res);
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
